export const PRISTINE = 'PRISTINE';
export const PENDING = 'PENDING';
export const FAILURE = 'FAILURE';
export const SUCCESS = 'SUCCESS';
